// Mid-article full-bleed banner inviting readers to book a demo.
export function MidArticleDemoBanner() {
  return (
    <div
      className="relative my-14 overflow-hidden bg-[linear-gradient(135deg,#6366F1_0%,#4F46E5_100%)] px-[clamp(24px,5vw,80px)] py-[clamp(36px,5vw,56px)]"
      style={{
        marginLeft: "calc(50% - 50vw)",
        marginRight: "calc(50% - 50vw)",
      }}
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-20 -right-16 h-80 w-80 rounded-full bg-[radial-gradient(circle,rgba(165,180,252,0.35)_0%,transparent_70%)]"
      />
      <div className="demo-banner-grid relative z-[1] mx-auto grid max-w-[1100px] grid-cols-1 items-center gap-[clamp(20px,4vw,48px)] md:grid-cols-[1fr_auto]">
        <div>
          <div className="mb-3.5 inline-flex items-center gap-2 rounded-full bg-white/20 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.08em] text-white backdrop-blur-md">
            See it in action
          </div>
          <h3 className="font-companion m-0 max-w-[640px] text-[clamp(24px,3vw,32px)] font-bold leading-[1.2] tracking-[-0.02em] text-white [text-wrap:balance]">
            Curious about how Companion works? Book a 1-on-1 demo with us.
          </h3>
        </div>
        <a
          href="https://calendly.com/d/cvxs-349-5w3/companion-askcompanion-com"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 justify-self-start whitespace-nowrap rounded-full bg-white px-5 py-2.5 text-sm font-semibold tracking-[-0.005em] text-indigo-600 no-underline shadow-[0_10px_24px_-10px_rgba(0,0,0,0.25)] transition-transform duration-150 ease-[ease] hover:-translate-y-px"
        >
          Book a demo
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path
              d="M5 12h14M13 5l7 7-7 7"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </a>
      </div>
    </div>
  );
}
